import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { scrollbar } from 'utils/styles';

export const StyledResourcesFilter = styled('div')(
  () => css`
    .filter-resources {
      position: relative;
      .items-list {
        background: #ffffff;
        border: 1px solid #eeeeee;
        border-radius: 6px;
        margin-top: 8px;
        overflow: auto;
        overflow-x: hidden;
        max-height: 300px;
        left: 0;
        right: 0;
        top: 45px;
        z-index: 1;
        ${scrollbar(0)};
        &:hover {
          ${scrollbar(0, '#9b9ea0')};
        }
        .item {
          cursor: pointer;
          border-bottom: 1px solid #e4e9ec;
          padding: 8px;
          &:hover {
            background-color: #e4e9ec;
          }
          .resource-title {
            font-weight: bold;
            font-size: 0.875rem;
            margin-left: 20px;
          }
          .username {
            color: #777777;
            margin-right: 4px;
            font-weight: bold;
            max-width: 115px;
          }
          .avatar {
            width: 36px;
            height: 36px;
            background: rgba(0, 0, 0, 0.03);
            border: 1px solid #edf2f7;
            box-sizing: border-box;
            box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
            border-radius: 6px;
            margin-left: 8px;
          }
          .number-label {
            font-size: 0.625rem;
          }
          &.selected {
            opacity: 0.3;
            cursor: not-allowed;
            label {
              cursor: not-allowed;
            }
          }
        }
      }

      .search-icon {
        margin-right: 15px;
      }
      .selected-resources {
        padding: 12px 10px;
        box-sizing: border-box;
        margin: 8px 0 16px 0;
        background: #f9f9f9;
        border: 1px solid #f5f5f5;
        box-sizing: border-box;
        border-radius: 8px;
        .resources {
          row-gap: 8px;
          column-gap: 8px;
          flex-wrap: wrap;
          .resource {
            background-color: #e1e8ff;
            padding: 8px 12px;
            border-radius: 6px;
            color: #6c879b;
            font-size: 0.75rem;
            .icon {
              margin-right: 10px;
              width: 17px;
              cursor: pointer;
            }
          }
        }
      }
    }
  `
);
